export function handleLineItemClick({
  quickbooksItemId,
  companyId,
  amount,
  month,
  navigate,
}) {
  console.log("CLICK:", {
    quickbooksItemId,
    companyId,
    amount,
    month,
  });

  // ALWAYS validate first — MoM or not
  if (quickbooksItemId === -1 || quickbooksItemId == null) {
    alert("Could not extract data for this line item from QuickBooks");
    return;
  }

  // One navigation path, MoM just adds `month`
  navigate("line-item", {
    state: {
      quickbooksItemId,
      companyId,
      amount,
      month: month ?? null,
    },
  });
}
